import {
  avatarClasses as muiAvatarClasses,
  getAvatarUtilityClass,
  svgIconClasses,
} from '@mui/material';
import { badgeClasses } from '../badge';
import { AvatarSize, AvatarTheme } from './types';

const avatarSizeClasses: Record<AvatarSize, string> = {
  xs: getAvatarUtilityClass('xs'),
  sm: getAvatarUtilityClass('sm'),
  md: getAvatarUtilityClass('md'),
  lg: getAvatarUtilityClass('lg'),
  xl: getAvatarUtilityClass('xl'),
};

const avatarThemeClasses: Record<AvatarTheme, string> = {
  light: getAvatarUtilityClass('light'),
  dark: getAvatarUtilityClass('dark'),
  brand1: getAvatarUtilityClass('brand1'),
  brand4: getAvatarUtilityClass('brand4'),
  flamingo: getAvatarUtilityClass('flamingo'),
  turquoiseLight: getAvatarUtilityClass('turquoiseLight'),
  turquoiseDark: getAvatarUtilityClass('turquoiseDark'),
};

export const avatarClasses = {
  ...muiAvatarClasses,
  ...avatarSizeClasses,
  ...avatarThemeClasses,
};

export const avatarSizes: Record<
AvatarSize,
{
  container: number;
  svgPadding: number;
  badge: number;
}
> = {
  xs: { container: 16, svgPadding: 4, badge: 0 },
  sm: { container: 24, svgPadding: 6, badge: 12 },
  md: { container: 32, svgPadding: 8, badge: 14 },
  lg: { container: 40, svgPadding: 12, badge: 16 },
  xl: { container: 56, svgPadding: 16, badge: 20 },
};

export const getAvatarSizeCssMixin = (size: AvatarSize) => {
  const { container, svgPadding } = avatarSizes[size];

  return {
    width: container,
    height: container,
    fontSize: container / 2,
    [`.${svgIconClasses.root}`]: {
      width: container - svgPadding,
      height: container - svgPadding,
    },
  };
};

export const getAvatarSizeStyle = (size: AvatarSize) => {
  const { badge } = avatarSizes[size];

  return {
    [`&.${avatarClasses[size]}, .${badgeClasses[size]} &`]: {
      ...getAvatarSizeCssMixin(size),
    },
    [`.${badgeClasses[size]} .${badgeClasses.badge} &`]: {
      width: badge,
      height: badge,
      fontSize: badge / 2,
    },
  };
};
